import React, {useContext} from 'react';
import { firebase } from './Firebase';
import { UserContext } from '../App';
import { useHistory, useLocation } from 'react-router-dom';

const Login = () => {
    document.title = 'SIHAH - Login';
    const [user, setUser] = useContext(UserContext);
    const history = useHistory();
    const location = useLocation();
    const { from } = location.state || {from:{pathname:"/"}};

    // email login
    function subForm(e) {
        e.preventDefault();
        
        const form = document.querySelector('#login .loginForm');
        const loginEmail = form.email.value;
        const loginPassword = form.password.value;

        firebase.auth().signInWithEmailAndPassword(loginEmail, loginPassword)
        .then(result => {
            const {displayName, email} = result.user;
            const optUser = {
                signed: true,
                name: displayName,
                email: email,
                message: 'Login Successful'
            }
                setUser(optUser);
                history.replace(from);
            })
            .catch(error => {
                const optUser = {};
                optUser.message = error.message;
                setUser(optUser);
            })
    };

    return (
        <section id="login" className="py-5 my-sm-5 text-center">
            <h1 className="mb-5 mt-sm-5 pt-sm-5 title"><b>Admin Login</b></h1>
            <form className="px-2 loginForm" onSubmit={subForm}>
                <input type="email" className="form-control my-2" name="email" placeholder="Admin Email" required />
                <input type="password" className="form-control my-2" name="password" placeholder="Admin Password" required />
                <input type="submit" value="Login" className="text-white btn btn-one px-5" />
            </form>
            <h6 className="text-danger mt-3">{user.message}</h6>
        </section>
    );
}

export default Login;